import React, { useState } from "react";

import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { styled } from "@mui/system";
import { Tribuja } from "../../assets";



const Image = styled("img")({});

const aboutsection = {
  des: `Experience Ultra-Luxury living at Tribhuja, a landmark gated community designed to redefine urban living in Kollur, Hyderabad. Crafted with spacious homes, abundant natural light, elegant architecture, and world-class amenities, Tribhuja brings together comfort, sophistication, and timeless design in one extraordinary address.`,

  images: [
    {
      img: "https://dprstorage.b-cdn.net/RW/tribuja/4.png",
      h1: "Image 1",
    },

    {
      img: "https://dprstorage.b-cdn.net/RW/tribuja/15.png",
      h1: "Image 2",
    },

    {
      img: "https://dprstorage.b-cdn.net/RW/tribuja/13.png",
      h1: "Image 3",
    },

    {
      img: "https://dprstorage.b-cdn.net/RW/tribuja/18.png",
      h1: "Image 4",
    },

    {
      img: "https://dprstorage.b-cdn.net/RW/tribuja/8.png",
      h1: "Image 5",
    },
  ],

  highlights: [
    {
      h1: "9",
      d1: " Towers",
    },

    {
      h1: "9.16",
      d1: "Acres",
    },


    {
      h1: "1730",
      d1: "Units",
    },

    {
      h1: "G+37",
      d1: "Floors Per Tower",
    },
  ],
};

const AboutSectionGallery: React.FC = () => {
  const isMobile = useMediaQuery("(max-width:900px)");

  const [hovered, setHovered] = useState<number | null>(
    null
  );

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",

        height: {
          xs: "100vh",
          md: "100vh",
        },

        backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg.png")`,

        backgroundSize: "cover",

        backgroundPosition: "bottom center",

        overflow: "hidden",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        py: 6,

        "&::after": {
          content: '""',

          position: "absolute",

          top: 0,
          left: 0,

          width: "100%",
          height: "100%",

          backgroundColor:
            "rgba(0,0,0,0.6)",

          zIndex: 1,
        },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Box sx={{ color: "white" }}>
          {/* HEADING */}

          <Box
            sx={{
              textAlign: "center",

              color: "white",

              mb: 3,
            }}
          >
            <Typography
              variant="h4"
              sx={{

                fontFamily: "Luxury",
                fontWeight: 500,

                color: "#fff",

                letterSpacing: "1px",

                textTransform: "uppercase",

                mb: 2,
              }}
            >
             ABOUt
            </Typography>

            <Box
              sx={{
                width: {
                  xs: "120px",
                  md: "180px",
                },

                height: "2px",

                background:
                  "linear-gradient(to right, transparent, #fff, transparent)",

                mx: "auto",

                mb: 3,
              }}
            />

            <Typography
              variant="body2"
              sx={{
                fontSize: isMobile ? "14px" : "16px",

                maxWidth: "1000px",

                mx: "auto",

                color: "#ffffff",

                lineHeight: 1.8,

                opacity: 0.9,
                textAlign:{xs:"start",md:"center"}
              }}
            >
              {aboutsection.des}
            </Typography>
          </Box>

    

          {/* IMAGE GALLERY */}

          <Box
            sx={{
              display: "flex",

              justifyContent: "center",

              alignItems: "center",

              width: "100%",

              height: 300,

              gap: "10px",

              overflow: "hidden",

              position: "relative",

              zIndex: 2,

              mt: 4,
            }}
            onMouseLeave={() =>
              setHovered(null)
            }
          >
            {aboutsection.images.map(
              (imgData, index) => (
                <Image
                  key={index}
                  src={imgData.img}
                  alt={
                    imgData.h1 ||
                    `Gallery ${index + 1}`
                  }
                  onMouseEnter={() =>
                    setHovered(index)
                  }
                  sx={{
                    width:
                      hovered === index ||
                        (hovered === null &&
                          index === 0)
                        ? "50%"
                        : "8%",

                    height: "100%",

                    objectFit: "cover",

                    borderRadius: "10px",

                    border: "2px solid #fff",

                    transition:
                      "all ease-out 0.5s",

                    cursor: "pointer",

                    zIndex:
                      hovered === index
                        ? 2
                        : 1,
                  }}
                />
              )
            )}
          </Box>

          {/* HIGHLIGHTS */}

          <Grid
            container
            sx={{
              mt: 4,

              justifyContent: "center",

              alignItems: "stretch",

              textAlign: "center",

              position: "relative",
            }}
          >
            {aboutsection.highlights.map(
              (item, index) => (
                <Grid
                  item
                  xs={6}
                  md={3}
                  key={index}
                  sx={{
                    display: "flex",

                    flexDirection: "column",

                    justifyContent:
                      "space-between",

                    alignItems: "center",

                    position: "relative",

                    px: {
                      xs: 1,
                      md: 2,
                    },

                    py: {
                      xs: 3,
                      md: 0,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",

                      flexDirection: "column",

                      justifyContent:
                        "center",

                      alignItems: "center",

                      textAlign: "center",

                      color: "white",

                      height: "100%",
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                          fontFamily: "Luxury",
                        fontSize: {
                          xs: "22px",
                          md: "30px",
                        },

                        lineHeight: 1.2,

                        minHeight: {
                          xs: 35,
                          md: 45,
                        },

                        display: "flex",

                        alignItems: "center",

                        justifyContent:
                          "center",

                        color: "white",
                      }}
                    >
                      {item.h1}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        // fontFamily: "Season",
                        fontSize: {
                          xs: "14px",
                          md: "16px",
                        },

                        fontWeight: 300,

                        letterSpacing: 0.5,

                        lineHeight: 1.6,

                        minHeight: {
                          xs: 40,
                          md: 45,
                        },

                        display: "flex",

                        alignItems:
                          "flex-start",

                        justifyContent:
                          "center",

                        color: "white",
                      }}
                    >
                      {item.d1}
                    </Typography>
                  </Box>

                  {/* VERTICAL DIVIDER */}

                  {index !==
                    aboutsection.highlights
                      .length -
                    1 &&
                    !(
                      isMobile &&
                      index === 1
                    ) && (
                      <Box
                        sx={{
                          position:
                            "absolute",

                          right: "-2px",

                          top: "50%",

                          transform:
                            "translateY(-50%)",

                          height: "40px",

                          width: "1px",

                          background:
                            "white",

                          opacity: 0.5,
                        }}
                      />
                    )}

                  {/* MOBILE DIVIDER */}

                  {isMobile &&
                    index % 2 !== 0 &&
                    index !==
                    aboutsection
                      .highlights
                      .length -
                    1 && (
                      <Box
                        sx={{
                          position:
                            "absolute",

                          bottom: 0,

                          left: "0%",

                          transform:
                            "translateX(-25%)",

                          height: "1px",

                          width: "500px",

                          background:
                            "white",

                          opacity: 0.5,
                        }}
                      />
                    )}
                </Grid>
              )
            )}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutSectionGallery;